import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';

import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ConditionalFormModule } from '../conditional-form/conditional-form.module';
import { MatSelectModule } from '@angular/material/select';
import { CarrierPortalComponent } from '../carrier-portal/carrier-portal.component';
import { CarrierPolicyDetailsComponent } from '../carrier-portal/carrier-policy-details/carrier-policy-details.component';
import { BookManagementComponent } from './book-management-shell/book-management.component';
import { BmWidgetFiltersComponent } from './bm-widget-filters/bm-widget-filters.component';
import { SimpleChipFilterComponent } from './bm-widget-filters/simple-chip-filter/simple-chip-filter.component';
import { HomeOfficeReportsComponent } from './home-office-reports/home-office-reports.component';
import { RepReportsComponent } from './rep-reports/rep-reports.component';
import { PolicyDetailsComponent } from './policy-details/policy-details.component';
import { BmLaunchModalComponent } from './bm-launch-modal/bm-launch-modal.component';
import { ContractStatsComponent } from './widgets/contract-stats/contract-stats.component';
import { TopPerformersComponent } from './widgets/top-performers/top-performers.component';
import { TopPolicyReviewComponent } from './widgets/top-policy-review/top-policy-review.component';
import { PolicyAlertsComponent } from './widgets/policy-alerts/policy-alerts.component';
import { ContractSummaryComponent } from './widgets/contract-summary/contract-summary.component';

//Kendo Imports
import { GridModule } from '@progress/kendo-angular-grid';

//Services
import { AuthService } from '../services/auth-service.service';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { BookManagementService } from './book-management.service';

import { BookManagementRouting } from './book-management-routing.module';

@NgModule({
  imports: [
    MatSelectModule,
    CommonModule,
    RouterModule,
    BookManagementRouting,
    FormsModule,
    ReactiveFormsModule,
    ConditionalFormModule,
    NgxDatatableModule,
    GridModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
      fullScreenBackdrop: true,
      backdropBorderRadius: '0',
      primaryColour: 'rgb(38, 91, 151)',
      secondaryColour: 'rgba(38, 91, 151, 0.2)',
      tertiaryColour: '#265b97',
    }),
    SharedComponentsModule,
    CdkDrag,
    CdkDropList,
  ],
  declarations: [
    CarrierPortalComponent,
    CarrierPolicyDetailsComponent,
    BookManagementComponent,
    BmWidgetFiltersComponent,
    SimpleChipFilterComponent,
    HomeOfficeReportsComponent,
    RepReportsComponent,
    PolicyDetailsComponent,
    BmLaunchModalComponent,
    ContractStatsComponent,
    TopPerformersComponent,
    TopPolicyReviewComponent,
    PolicyAlertsComponent,
    ContractSummaryComponent,
  ],
  providers: [
    RightBridgeApiService,
    BookManagementService,
    AuthService,
    CdkDrag,
    CdkDropList,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BookManagementModule {}
